import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MyPDDLoan, MyPDDState } from './types';

const initialState: MyPDDState = {
  pendingPDD: 0,
  criticalPDD: 0,
  loans: [],
  loading: false,
  error: '',
};

const myPDDSlice = createSlice({
  name: 'myPDD',
  initialState,
  reducers: {
    setMyPDDLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setMyPDDData(
      state,
      action: PayloadAction<{
        pendingPDD: number;
        criticalPDD: number;
        loans: MyPDDLoan[];
      }>,
    ) {
      state.pendingPDD = action.payload.pendingPDD;
      state.criticalPDD = action.payload.criticalPDD;
      state.loans = action.payload.loans;
      state.error = '';
    },
    setMyPDDError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loans = [];
      state.pendingPDD = 0;
      state.criticalPDD = 0;
    },
    resetMyPDDState(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { setMyPDDLoading, setMyPDDData, setMyPDDError, resetMyPDDState } =
  myPDDSlice.actions;

const reducer = {
  myPDD: myPDDSlice.reducer,
};

export default reducer;
